/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftRewardMetadata } from './NftRewardMetadata';
import {
    NftRewardMetadataFromJSON,
    NftRewardMetadataFromJSONTyped,
    NftRewardMetadataToJSON,
    NftRewardMetadataToJSONTyped,
} from './NftRewardMetadata';
import type { NftRewardPrize } from './NftRewardPrize';
import {
    NftRewardPrizeFromJSON,
    NftRewardPrizeFromJSONTyped,
    NftRewardPrizeToJSON,
    NftRewardPrizeToJSONTyped,
} from './NftRewardPrize';

/**
 * 
 * @export
 * @interface LootboxReward
 */
export interface LootboxReward {
    /**
     * 
     * @type {NftRewardMetadata}
     * @memberof LootboxReward
     */
    nftReward: NftRewardMetadata;
    /**
     * 
     * @type {Array<NftRewardPrize>}
     * @memberof LootboxReward
     */
    prizes: Array<NftRewardPrize>;
    /**
     * 
     * @type {number}
     * @memberof LootboxReward
     */
    levelCompleted?: number;
}

/**
 * Check if a given object implements the LootboxReward interface.
 */
export function instanceOfLootboxReward(value: object): value is LootboxReward {
    if (!('nftReward' in value) || value['nftReward'] === undefined) return false;
    if (!('prizes' in value) || value['prizes'] === undefined) return false;
    return true;
}

export function LootboxRewardFromJSON(json: any): LootboxReward {
    return LootboxRewardFromJSONTyped(json, false);
}

export function LootboxRewardFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootboxReward {
    if (json == null) {
        return json;
    }
    return {
        
        'nftReward': NftRewardMetadataFromJSON(json['nftReward']),
        'prizes': ((json['prizes'] as Array<any>).map(NftRewardPrizeFromJSON)),
        'levelCompleted': json['levelCompleted'] == null ? undefined : json['levelCompleted'],
    };
}

export function LootboxRewardToJSON(json: any): LootboxReward {
    return LootboxRewardToJSONTyped(json, false);
}

export function LootboxRewardToJSONTyped(value?: LootboxReward | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'nftReward': NftRewardMetadataToJSON(value['nftReward']),
        'prizes': ((value['prizes'] as Array<any>).map(NftRewardPrizeToJSON)),
        'levelCompleted': value['levelCompleted'],
    };
}

